export const CHAINS_LOGOS = {
    ETHEREUM: "/asset/chains/ethereum.png",
    ARBITRUM: "/asset/chains/arbitrum.png",
    KATANA: "/asset/chains/katana.png",
};
